import { trace } from 'owa-trace';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function logTraceIfParamPresent(message: string, ...informationSources: any[]): void {
    if (window.location.search.includes('enableTracing')) {
        if (informationSources.length == 0) {
            trace.info(message);
            return;
        }
        informationSources.forEach(info => {
            try {
                trace.info(message + JSON.stringify(info));
            } catch {
                trace.info(message);
            }
        });
    }
}
